import { useRef, forwardRef, useImperativeHandle, useCallback } from 'react';
import NaviFrom from './naviForm';
import NaviTypeTab from './naviTypeTab';
import NaviSetting from './naviSetting';

const NaviFormComponent = forwardRef((props, ref) =>{
  let { 
  naviSearch,
  setNaviSearch,
  map,
  naviStart,
  setNaviStart,
  naviEnd,
  setNaviEnd,
  setResultError,
  isShowNavi,
  naviFromToggle,
  isTablet
} = props;


// 経由地関連の設定
let {naviVia1, naviVia2 ,naviVia3 ,naviVia4 ,naviVia5,
  setNaviVia1, setNaviVia2 ,setNaviVia3 ,setNaviVia4 ,setNaviVia5} = props;
let vias = [[naviVia1, setNaviVia1], [naviVia2, setNaviVia2] ,[naviVia3, setNaviVia3],
  [naviVia4, setNaviVia4] ,[naviVia5, setNaviVia5]];

const startRef = useRef();
const endRef = useRef();
const viaRef = useRef(); // 現状使用しないけど便宜的設定

  const toggleStartEnd = () => {
    // startとendの子要素の位置決定メソッドを呼び出す
    let {current: {setDestination: startSetDestination}} = startRef;
    let {current: {setDestination: endSetDestination}} = endRef;

    let {name: sName, lat: sLat, lon: sLon} = naviStart;
    let {name: eName, lat: eLat, lon: eLon} = naviEnd;

    // startとendのデータを入れ替えてリサーチする
    startSetDestination({name: eName, lat:eLat, lon: eLon});
    endSetDestination({name: sName, lat:sLat, lon: sLon});
    let {drive:{st_road_type, ed_road_type}} = naviSearch;
    naviSearch.drive["st_road_type"] = ed_road_type;
    naviSearch.drive["ed_road_type"] = st_road_type;
    naviSearch.reSearchFlag = true;
    setNaviSearch(naviSearch);
  };

  const addVias = () =>{
    let existIndex = vias.reduce((acc, [via], idx)=>{
      if(via){
        return idx; // データが存在するviaのindexを保持
      }
      return acc;
    }, -1); // -1の場合は何も存在しない

    
    if((existIndex+1) === 5){ // 6番目以上は仕様上そんざいしない
      return;
    }
    // 存在するindexの次のviaをセットする
    let [, setVia]= vias[existIndex+1];
    setVia({name: null, lat: null, lon:null});
  }

  const delVias = ()=>{
    let [[, setVia]] = vias.reduceRight((acc, [via, setVia])=>{
      if(via){
        acc.push([via, setVia]);
      }
      return acc;
    },[]);
    setVia(null);
  }

  // 外部コンポーネントからのナビルート設定
  const setNaviRoute = useCallback(({name, lat, lon}) => {
    // startとendの子要素の位置決定メソッドを呼び出す
    let {current: {setCurrentLocation: startSetCurrentLocation, setDestination: startSetDestination}} = startRef;
    let {current: {setDestination: endSetDestination}} = endRef;

    // 目的地をセット
    endSetDestination({name, lat, lon});

    // SPだったら出発地は現在地をセットする
    // もし、現在地セットがイマイチだったら外してもいいかも
    if(isTablet){
      startSetDestination({name: null, lat:null, lon:null}); // 事前にセットされてるかもなので一旦カラにしておく
      startSetCurrentLocation();
    } else {
      // PCの場合はあえて出発地に手を加えない
      // 出発地を設定済みの場合はPOIのルート検索を押せば目的地がコロコロ変わる
    }

    // 長押しから来る場合はすでにナビフォームが表示されているのでリサーチフラグを立てておく
    naviSearch.reSearchFlag = true;
    setNaviSearch(naviSearch);
  }, [naviSearch, setNaviSearch, isTablet]);

  useImperativeHandle(ref, () => ({
    setNaviRoute: setNaviRoute
  }));
  
  let {type} = naviSearch;

  return (
  <div className="navi-form-component">
    <button className="back-button" title="通常検索に戻る" onClick={(e) => { e.stopPropagation(); naviFromToggle(); }}>
      <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/keyboard_backspace_24.svg')` }}></i>
      <span className="back-text">戻る</span>
    </button>

    <div className="route-inputs">
      <NaviFrom
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        formType={'start'}
        map={map}
        formData={naviStart}
        setFormData={setNaviStart}
        setResultError={setResultError}
        driveHighwayType={"st_road_type"}
        ref={startRef}
        isShowNavi={isShowNavi}
      />
      
      {type ==="drive" && vias.some(([via])=>via) // ドライブ、かつ、経由地が一つでもある場合は経由地表示レイアウトにする
        ?(
          <div className="route-swap-and-via">
            {/* 入れ替えボタン */}
            <div className="swap-route-wrap">
              <button className="swap-route-btn" title="出発地と目的地を入れ替え"
                  onClick={toggleStartEnd}>
                  <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/swap_vert_24.svg')` }}></i>
              </button>
            </div>
            <div className="route-via-wrap">
              {type === "drive" && vias.filter(([via])=>via) // viaがnullじゃないものは表示する
              .map(([via, setVia], idx)=>{
                return (
                  <NaviFrom
                    className="navi-via-form"
                    naviSearch={naviSearch}
                    setNaviSearch={setNaviSearch}
                    formType={'via'}
                    map={map}
                    formData={via}
                    setFormData={setVia}
                    setResultError={setResultError}
                    driveHighwayType={`m_road_type${idx+1}`}
                    ref={viaRef}
                    isShowNavi={isShowNavi}
                  /> 
                );
              })}
            </div>
          </div>
        )
        : <button className="swap-route-btn" title="出発地と目的地を入れ替え"
              onClick={toggleStartEnd}>
              <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/swap_vert_24.svg')` }}></i>
          </button>
      }

      

      <NaviFrom
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        formType={'end'}
        map={map}
        formData={naviEnd}
        setFormData={setNaviEnd}
        setResultError={setResultError}
        driveHighwayType={"ed_road_type"}
        ref={endRef}
        isShowNavi={isShowNavi}
      />

      {type === "drive" && (
        <div>
          <div id="navi-add-via" class={vias.every(([via])=>via)? "navi-add-via-hide": ""} onClick={addVias}>
            <i className="svg-icon-blue icon-inner" style={{ backgroundImage: `url('assets/icons/plus_24.svg')` }}></i>
            経由地を追加
          </div>
          {vias.some(([via])=>via) && <div id="navi-del-via" onClick={delVias}>
              <i className="svg-icon-blue icon-inner" style={{ backgroundImage: `url('assets/icons/minus_24.svg')` }}></i>
              経由地を削除
            </div>
          }
        </div>
      )}

      {/* 交通手段選択タブ */}
      <NaviTypeTab
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        setResultError={setResultError}
      />

      {/* 検索ボタン */}
      <button className="route-search-btn" id="execute-route-search"
        onClick={() => setNaviSearch({...naviSearch, reSearchFlag: true})}>
          <i className="svg-icon-white" style={{ backgroundImage: `url('assets/icons/route_24.svg')` }}></i>
          ルート検索
      </button>

      {/* 詳細設定 */}
      <NaviSetting 
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
      />

      
    </div>
  </div>
  ); 
});

export default NaviFormComponent;